import React from 'react';
import { professionsList } from 'const/professions';
import { View } from '@coinscrap/webapp-core';
import InputLabel from 'components/InputLabel/InputLabel';




export const Profession = ({ professionCode, setProfession, setProfessionCode }) => {
	return (
		<View inputFreeRowSt>
			<InputLabel
				value={professionCode || ''}
				onChange={(value) => {
					setProfession(professionsList?.find((p) => p?.VALUE === value)?.NAME);
					setProfessionCode(value);
				}}
				label={'¿A qué te dedicas?'}
				type="autoSuggest"
				selectOptions={professionsList.map((item) => {
					return {
						label: item.NAME,
						value: item.VALUE,
					};
				})}
			/>
		</View>
	);
};
